import { render, staticRenderFns } from "./course-order.vue?vue&type=template&id=7018541e&scoped=true"
import script from "./course-order.vue?vue&type=script&lang=js"
export * from "./course-order.vue?vue&type=script&lang=js"
import style0 from "./course-order.vue?vue&type=style&index=0&id=7018541e&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7018541e",
  null
  
)

export default component.exports